import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { useTurnAuthoritySnapshot, DEFAULT_TURN_AUTHORITY_SNAPSHOT } from './TurnAuthoritySnapshotContext'
import type { MarkerSelectionData } from 'tripPlanner/components/Chat/chatMapConstants'
import type { RightPanelView } from '../hooks/useRightPanelState'

interface Props {
  rightPanelView: RightPanelView | 'chat'
  selectedMarkerData: MarkerSelectionData | undefined
}

export function RightPanelSnapshotRegistration({
  rightPanelView,
  selectedMarkerData,
}: Props) {
  const snapshotRef = useTurnAuthoritySnapshot()
  const owner = useRef(Symbol('surface contribution')).current

  useIsomorphicLayoutEffect(() => {
    snapshotRef.current.rightPanelOwner = owner
    snapshotRef.current.rightPanelView = rightPanelView
    snapshotRef.current.selectedMarkerData = selectedMarkerData
  }, [owner, snapshotRef, rightPanelView, selectedMarkerData])

  // Separate effect, empty deps -- runs its cleanup only on true unmount, not on every value
  // change. Desktop and mobile registrations are mutually exclusive, and the
  // desktop/mobile surface can flip at runtime (viewport resize/rotation), not just on initial
  // load -- without this, these fields would freeze at their last desktop values indefinitely
  // once the surface switches to mobile.
  useIsomorphicLayoutEffect(() => () => {
    if (snapshotRef.current.rightPanelOwner !== owner) return
    snapshotRef.current.rightPanelOwner = undefined
    snapshotRef.current.rightPanelView = DEFAULT_TURN_AUTHORITY_SNAPSHOT.rightPanelView
    snapshotRef.current.selectedMarkerData = DEFAULT_TURN_AUTHORITY_SNAPSHOT.selectedMarkerData
  }, [owner, snapshotRef])

  return null
}
